import styled, { css } from "styled-components";

interface InputRadioStyleProps {
  $size?: "sm" | "md" | "lg";
}

export const InputRadio = styled.div<InputRadioStyleProps>`
  width: 100%;
  padding: 3px;
  display: flex;
  background: ${(props) => props.theme.colors.inputBg};
  border-radius: 6px;

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 56px;
    `}

  ${(props) =>
    props.$size === "md" &&
    css`
      height: 48px;
    `}

      ${(props) =>
    props.$size === "sm" &&
    css`
      height: 38px;
    `}
`;

export const Label = styled.label<InputRadioStyleProps>`
  width: 100%;
  color: ${(props) => props.theme.colors.inputPlaceholder};
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;

  input {
    display: none;
  }

  &:has(input:checked) {
    color: ${(props) => props.theme.colors.white100};
    cursor: default;
    background: ${(props) => props.theme.colors.primary100};
    font-weight: 700;
  }

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 50px;
      font-size: 1.6rem;
    `}

  ${(props) =>
    props.$size === "md" &&
    css`
      height: 42px;
      font-size: 1.4rem;
    `}

      ${(props) =>
    props.$size === "sm" &&
    css`
      height: 32px;
      font-size: 1.3rem;
    `}
`;
